/**
 * User: Lior Elrom
 * Date: 03/21/16
 * Time: 3:49 PM
 */

'use strict';

const PRODUCT_CATEGORY = 'product';
const CHECKOUT_CATEGORY = 'checkout';

module.exports = {
    getCarouselCategory(owner) {
        switch (owner) {
            case 'checkout':
                return CHECKOUT_CATEGORY;
            default:
                return PRODUCT_CATEGORY;
        }
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/helpers/carouselHelpers.es.js